<template>
  <v-item
    v-slot="{ toggle }"
    :value="item.reference.id"
    @change="$emit('click')"
  >
    <v-list-item
      class="reference-log-item py-4 px-6 justify-start"
      :class="classes"
      @click="toggle"
    >
      <v-icon
        v-if="hasIcon"
        left
        :color="iconColorProp"
        class="mr-4 material-icons-outlined"
      >
        {{ item.icon }}
      </v-icon>
      <span
        :class="textClassProp"
        class="text-body-2 font-weight-bold title"
      >
        {{ item.reference.publication.title }}
      </span>
    </v-list-item>
  </v-item>
</template>

<script>
import { ReferenceLogItemModel } from '@/models';

export default {
  name: 'ReferenceLogItem',
  props: {
    item: {
      type: ReferenceLogItemModel,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        [this.item.color]: !this.selected,
        [this.item.selectedColor]: this.selected,
      };
    },
    textClassProp() {
      return this.selected
        ? this.item.selectedTextClass
        : this.item.textClass;
    },
    iconColorProp() {
      return this.selected
        ? this.item.selectedIconColor
        : this.item.iconColor;
    },
    hasIcon() {
      return !!this.item.icon;
    },
  },
};
</script>

<style scoped>
.reference-log-item {
  display: flex;
  align-content: center;
  justify-content: center;
  width: 100%;
}

.reference-log-item .title {
  line-height: 150%;
}
</style>
